/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function trace(x, transform = y => y) {
    // Logs the passed value, a stack trace to the call site of this function,
    // and returns the value unchanged. Optionally pass a transformation
    // function which is applied only to the logged value.
    // eslint-disable-next-line no-console
    console.log(transform(x), new Error().stack);
    return x;
}
